import type { Ctx } from '@milkdown/kit/ctx';

import { insertTextAtCursor } from './utils';

export enum DateType {
  DATE = 'date',
  TIME = 'time',
  DATE_TIME = 'date_time',
}

export type DateTimeSlashMenuItemProps = {
  type: DateType;
  locale?: string;
};

export const dateTimeSlashMenuItem = ({ type, locale = 'en-US' }: DateTimeSlashMenuItemProps) => {
  let label = 'Current date and time';
  let icon = '📅';

  switch (type) {
    case DateType.DATE:
      label = 'Current date';
      icon = '📅';
      break;
    case DateType.TIME:
      label = 'Current time';
      icon = '🕒';
      break;
    case DateType.DATE_TIME:
      label = 'Current date and time';
      icon = '📅';
      break;
  }

  return {
    label,
    icon,
    onRun: (ctx: Ctx) => {
      const text = new Date().toLocaleString(locale, {
        ...(type === DateType.DATE && {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }),
        ...(type === DateType.TIME && {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        }),
        ...(type === DateType.DATE_TIME && {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        }),
      });
      insertTextAtCursor(ctx, text);
    },
  };
};
